import React, { useState } from "react";

export default function Contact({ t }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }
  async function handleSubmit(e) {
    e.preventDefault();
    
    try {
     const response = await fetch("https://italiano988.com/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
         body: JSON.stringify(form),
      });
     const result = await response.json();
     console.log(result);
      if (result.success) {
        alert("✅ تم إرسال الرسالة بنجاح");
      } else {
        alert("❌ حصل خطأ: " + result.message);
      }
    } catch (error) {
      console.error(error); 
       alert("❌ خطأ في الاتصال بالسيرفر");
    }
    setSent(true);
    setTimeout(() => setSent(false), 3000);

  }

  return (
    <section className="py-5">
      <div className="container">
        <h1 className="fw-bold mb-4 text-center mt-5">{t("contact.title")}</h1>
        <div className="row g-4">
          {/* الفورم */}
          <div className="col-lg-6">
            <form className="card border-0 shadow-sm" onSubmit={handleSubmit}>
              <div className="card-body p-4">
                <div className="mb-3">
                  <label className="form-label">{t("contact.name")}</label>
                  <input name="name" className="form-control" value={form.name} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("contact.email")}</label>
                  <input type="email" name="email" className="form-control" value={form.email} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("contact.phone")}</label>
                  <input name="phone" className="form-control" value={form.phone} onChange={handleChange} />
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("contact.message")}</label>
                  <textarea name="message" className="form-control" rows="5" value={form.message} onChange={handleChange} required />
                </div>
                <button className="btn btn-primary" type="submit">
                  <i className="bi bi-send me-2"></i>
                  {t("contact.send")}
                </button>
                {sent && (
                  <div className="alert alert-success mt-3 mb-0">
                    {t("contact.success")}
                  </div>
                )}
              </div>
            </form>
          </div>

          <div className="col-lg-6">
            <div className="p-4 rounded shadow bg-body-tertiary h-100">
              <h5 className="fw-bold">{t("contact.info")}</h5>
              <p className="text-secondary mb-1">
                <i className="bi bi-geo-alt me-2"></i>  
              </p>
              <p>{t("contact.address")}</p>
              <p className="text-secondary mb-1">
                <i className="bi bi-telephone me-2"></i> 
              </p>
              <p>{t("contact.mobile")}</p>
              <p className="text-secondary">
                <i className="bi bi-envelope me-2"></i> 
              </p>
              <p>{t("contact.mail")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
